/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './AcupunctureLimitations.scss'
import { IInpatientTypeInsurance, ILimitation } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { CommonUtils } from '../../../../utils/CommonUtils'
import parse from 'html-react-parser'

export interface IAcupunctureLimitationsProps {
	data: IInpatientTypeInsurance
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAcupunctureLimitationsState {}

export class AcupunctureLimitations extends React.Component<IAcupunctureLimitationsProps, IAcupunctureLimitationsState> {
	render(): React.ReactNode {
		const model = this.props.data
		let first = true

		if (model.limitations && model.limitations.length > 0) {
			return model.limitations.map((element, index) => {
				const getLines = (limitation: ILimitation): string => {
					first = false
					let line = ''
					if (limitation.remaining === 0 || limitation.remaining > 1) {
						line = `<strong>${limitation.remaining}</strong> Sessions Remaining`
					} else if (limitation.remaining === 1) {
						line = `<strong>${limitation.remaining}</strong> Session Remaining`
					}

					if (limitation.message && limitation.message.trim() !== '') {
						line += ' - ' + limitation.message
					}
					if (CommonUtils.isValidDate(limitation.eligibleDate)) {
						line += `&nbsp;&nbsp; <br /> Next Eligible: ${CommonUtils.toDisplayDate(limitation.eligibleDate)}`
					}
					if (CommonUtils.isValidDate(limitation.effectiveDate)) {
						line += `&nbsp;&nbsp;<br/> Effective Date: ${CommonUtils.toDisplayDate(limitation.effectiveDate)}`
					}

					return line
				}
				return (
					<tr key={index}>
						<td>{first ? 'Limitations:' : ''}</td>
						<td colSpan={3}>{parse(getLines(element))}</td>
					</tr>
				)
			})
		} else return <></>
	}
}
